import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AccountSelectorCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 50px;
  padding: ${Spacing.S8} ${Spacing.S12};
  border: 1px solid ${Color.Grey200};
  border-left: 0;
  border-top-right-radius: ${DefaultValue.BorderRadius};
  border-bottom-right-radius: ${DefaultValue.BorderRadius};

  label {
    margin-bottom: 0;
  }

  label span {
    display: none;
  }

  & .disabled {
    border-color: ${Color.Grey200};
    background-color: ${Color.Grey100};
    box-shadow: none;
    color: ${Color.Grey200};

    &::placeholder: {
      color: ${Color.Grey200};
    }
  }

  > div {
    margin-right: 0;
  }
`
